// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .transaction-item[data-v-9c71aa6e]{border-bottom:1px solid #f2f2f2;padding:11px 0}.media[data-v-9c71aa6e]{min-width:34%!important}", ""]);
// Exports
module.exports = exports;
